export function initMicrosoft() {
  if (!document.getElementById('MicrosoftAdvertisingScript')) {
    (function (w, d, t, r, u) {
      let f, n, i
      // eslint-disable-next-line no-unused-expressions, no-sequences
      w[u] = w[u] || [], f = function () {
        const o = {
          ti: '17506308',
        }
        // eslint-disable-next-line no-unused-expressions, no-undef, no-sequences
        o.q = w[u], w[u] = new UET(o), w[u].push('pageLoad')
      }, n = d.createElement(t), n.src = r, n.async = 1, n.id = 'MicrosoftAdvertisingScript', n.onload = n.onreadystatechange = function () {
        const s = this.readyState
        // eslint-disable-next-line no-unused-expressions, no-mixed-operators
        s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null)
      }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')
  }
}
